import { useGT } from 'gt-react';
import type { WorkbookPivotSheet } from '@erp/shared-types';
import { pivotGroupName, pivotValueName } from '@erp/workbooks';

/** A pivot Worksheet's configuration in the Process: what it groups by, spreads and summarizes. */
export function PivotProcessDetails({ sheet }: { sheet: WorkbookPivotSheet }) {
  const gt = useGT();
  const { pivot } = sheet;
  const context = 'workbook process pivot summary';
  const lines = [
    pivot.filters.length &&
      gt('Filter by {fields}.', {
        context,
        fields: pivot.filters.map((filter) => filter.column).join(', '),
      }),
    pivot.rows.length &&
      gt('Group rows by {fields}.', {
        context,
        fields: pivot.rows.map(pivotGroupName).join(', '),
      }),
    pivot.columns.length &&
      gt('Spread {fields} into columns.', {
        context,
        fields: pivot.columns.map(pivotGroupName).join(', '),
      }),
    pivot.values.length &&
      gt('Summarize {values}.', {
        context,
        values: pivot.values.map(pivotValueName).join(', '),
      }),
  ].filter((line): line is string => typeof line === 'string');
  return (
    <>
      {lines.map((line) => (
        <p key={line} className="text-sm text-muted-foreground">
          {line}
        </p>
      ))}
    </>
  );
}
